import { render, staticRenderFns } from "./bxDcMealsList.vue?vue&type=template&id=ba66c506&scoped=true&"
import script from "./bxDcMealsList.vue?vue&type=script&lang=js&"
export * from "./bxDcMealsList.vue?vue&type=script&lang=js&"
import style0 from "./bxDcMealsList.vue?vue&type=style&index=0&id=ba66c506&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba66c506",
  null
  
)

export default component.exports